import { MailWizz } from '@/models/mailwizz/mailwizz';
import { BaseModule } from './base-module'
import { Module, Action } from 'vuex-class-modules'
import { mailWizzService } from '@/services/mailwizz-service'
import store from '@/store';

@Module({ generateMutationSetters: true })
class MailWizzModule extends BaseModule<MailWizz> {
    cloneRecord(record: MailWizz): MailWizz { return MailWizz.clone(record) }
    copyRecord(record: MailWizz): MailWizz { return MailWizz.clone(record, { id: 0 }) }
    createRecord(): MailWizz { return new MailWizz() }
    apiService() { return mailWizzService }

    @Action
    getRecords(params?: any) { return this._baseGetRecords(params) }

    @Action
    save() { return this._baseSave() }

    @Action
    delete(resetRecords: boolean = true) { return this._baseDelete(resetRecords) }
}

export const mailWizzModule = new MailWizzModule({ store, name: 'default' })
